import * as React from 'react';
import { useDataLoader } from 'react-remote-data-hooks';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { toastr } from 'react-redux-toastr';
import api from '../../../../api';
import CreateForm from './CreateForm';
import { StatusCodes } from 'http-status-codes';
import { AppPermissions, ITag, useHasPermission } from '../../../../core';

const Tag: React.FunctionComponent = () => {
  const canCreateTag = useHasPermission(AppPermissions.CreateTag);
  const canDeleteTag = useHasPermission(AppPermissions.DeleteTag);
  const canUpdateTag = useHasPermission(AppPermissions.UpdateTag);
  const [editModal, setEditModal] = useStateWithCallbackLazy<{
    data?: ITag;
    isOpen?: boolean;
  }>({});
  const [updateError, setUpdateError] = React.useState('');
  const [updating, setUpdating] = React.useState(Boolean);
  const { data, reload } = useDataLoader<ITag[]>(() => api.tag.loadAllTags());

  const tagUpdate = async (updateData: ITag) => {
    if (updateData.name.trim() === '') {
      toastr.error('Error', 'The tag cannot be empty spaces!');
    } else {
      try {
        const id = editModal?.data?._id;
        const name = updateData.name;
        let isTagExist: boolean = false;
        data.map(
          (tag) =>
            tag.name.toLocaleLowerCase().trim() ===
              name.toLocaleLowerCase().trim() &&
            tag._id !== id &&
            (isTagExist = true)
        );
        if (isTagExist) {
          toastr.error('Error', 'The tag already exists!');
        } else {
          setUpdating(true);
          const response = id
            ? await api.tag.updateTag(updateData, id)
            : await api.tag.createTag(updateData);
          if (response.status === StatusCodes.OK) {
            setEditModal({}, () => {
              reload();
            });
          } else {
            setUpdateError('Unable to update details');
          }
          setUpdating(false);
        }
      } catch (error) {
        setUpdateError('Unable to update details');
        setUpdating(false);
      }
    }
  };

  const showCreateModal = () => {
    setEditModal({}, () => {
      setEditModal({ isOpen: true }, () => {
        // console.log("model closed")
      });
    });
  };

  const onDelete = async (id?: string) => {
    try {
      await api.tag.deleteTag(id);
      toastr.success('Success', 'Tag deleted successfully');
      reload();
      closeModal();
    } catch (error) {
      toastr.error('Error', error?.response?.data?.message);
    }
  };

  const closeModal = () => {
    setEditModal({}, () => {
      // console.log("model closed")
    });
  };

  const showEditModal = (modeData: ITag) => {
    setEditModal({}, () => {
      setEditModal({ data: modeData, isOpen: true }, () => {
        // console.log("model closed")
      });
    });
  };

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Tags</h4>
          </div>
          {canCreateTag && (
            <div className="col-auto text-right">
              <button
                className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
                onClick={() => showCreateModal()}
              >
                <i className="icon-plus mr-1 font-xs"></i> Add
              </button>
            </div>
          )}
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => {
                return (
                  <tr
                    onClick={() => {
                      if (canDeleteTag || canUpdateTag) {
                        showEditModal(item);
                      }
                    }}
                    className="cursor-pointer"
                  >
                    <td>{item.name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModal.isOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <CreateForm
              onSubmit={(formData) => tagUpdate(formData)}
              isSubmitting={updating}
              error={updateError}
              data={editModal.data}
              onCancel={() => closeModal()}
              onDelete={(id?: string) => onDelete(id)}
            ></CreateForm>
          </>
        )}
      </div>
    </>
  );
};

export default Tag;
